import { render, staticRenderFns } from "./dialog-view-wrapper.vue?vue&type=template&id=571a7c6e"
import script from "./dialog-view-wrapper.vue?vue&type=script&lang=js"
export * from "./dialog-view-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('571a7c6e')) {
      api.createRecord('571a7c6e', component.options)
    } else {
      api.reload('571a7c6e', component.options)
    }
    module.hot.accept("./dialog-view-wrapper.vue?vue&type=template&id=571a7c6e", function () {
      api.rerender('571a7c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/campaign/dialog-view-wrapper.vue"
export default component.exports